import moment from "moment";
import {DATE_FORMAT} from "@/components/fields/DateField";
import cloneDeep from "bootstrap-vue/esm/utils/clone-deep";

export default {
    props: {
        elementData: {
            type: Object,
            required: true,
        },
        isComplication: {
            type: Boolean,
            default: false,
        },
    },
    data() {
        return {
            element: cloneDeep(this.elementData),
            date: null,
            prefix: '',
            updateFunction: Promise.resolve(null),
            createFunction: Promise.resolve(null),
            serverErrors: '',
        };
    },
    computed: {
        saveButtonTitle() {
            if (this.element.values.hasOwnProperty('id')) {
                return this.$t('utils.save');
            }
            return this.$t('utils.create');
        },
        elementDate() {
            return moment(this.element.values.date, moment.ISO_8601, true).format(DATE_FORMAT);
        }
    },
    methods: {
        save() {
            this.element.values.is_complication = this.isComplication;
            if (this.element.values.hasOwnProperty('id')) {
                this.updateFunction({
                    pk: this.element.values.id,
                    data: this.element.values,
                })
                    .then(this.processData)
                    .catch(this.processErrors);
            } else {
                this.createFunction(this.element.values)
                    .then(this.processData)
                    .catch(this.processErrors);
            }
        },
        processData() {
            this.serverErrors = '';
            this.$emit('save');
        },
        processErrors() {
            this.serverErrors = this.$t('error.general');
        },
        close() {
            this.$emit('close');
        },
        addTimeToDate({hour, minute}) {
            let date = moment(this.element.values.date, moment.ISO_8601, true);
            date.hour(hour);
            date.minute(minute);
            this.element.values.date = date.toISOString(true);
            this.date = this.element.values.date;
        },
    },
};